export class DialogueTree {
	dialogues
	startID
	currentID

	interactions = {}
	metadata = {}

	awaitingInteraction = null

	constructor(data) {
		this.dialogues = data.dialogue
		this.interactions = data.interactions || {}
		this.startID = data.start_id
		this.currentID = this.startID
		this.metadata = {};
		console.log("Creating new dialogue tree", this.startID, this.interactions, this.dialogues)
	}

	/**
	 * Called when the dialogue is finished
	 */
	isFinished() {
		return !this.currentID
	}

	onInteractionSuccess(e) {
		if (!this.awaitingInteraction)
			return

		this.metadata[this.awaitingInteraction.key] = e.detail
		console.log("dialogue_tree:onInteractionSuccess", e.detail, this.awaitingInteraction, this.metadata)

		if (this.awaitingInteraction.on_success !== "") {
			this.emitInteraction(this.awaitingInteraction.on_success, this.buildInteraction(this.awaitingInteraction.on_success)) //Trigger interaction
		} else {
			this.awaitingInteraction = null
		}
	}

	onInteractionError(e) {
		if (!this.awaitingInteraction)
			return

		console.log("OnError", e)
		this.currentID = this.awaitingInteraction.on_error
		this.awaitingInteraction = null
	}

	/**
	 * Called when player continues through dialogue after action
	 * @param data
	 */
	onNext(data = {}) {
		if (this.awaitingInteraction)
			return;

		const c = this.getCurrent()
		if (!c)
			return

		console.log("OnNext", c, data)
		switch (c.text_type) {
			case 0: //Simple
				this._handleSimpleNext(c, data)
				break
			case 1: //Multi
			case 6: //NFT Select
				this._handleMultiNext(c, data)
				break
			case 2: //Text Input
				this._handleTextInputNext(c, data)
				break
			case 3: //Number input
			case 4: //Token Number input
				this._handleNumberInputNext(c, data)
				break
		}

		if (data.meta)
			this.metadata = Object.assign({}, this.metadata, data.meta)

		console.log("Dialogue Metadata", JSON.stringify(this.metadata))

		if (!this.currentID) {
			//End of dialogue
			// this.onFinish()
			console.log("End of dialogue", this.metadata)
		}
	}

	/**
	 * Go to a given ID
	 * @param id
	 */
	go(id) {
		this.awaitingInteraction = false
		console.log("Going to dialogue", id)
		if (this.dialogues[id]) {
			this.currentID = id
		}
	}

	getNextID() {
		return this.getCurrent().next_id
	}

	getCurrent() {
		return this.dialogues[this.currentID]
	}

	getMetadata() {
		return this.metadata
	}

	_handleSimpleNext(current, data) {
		//Interaction
		if (current.interaction_trigger_id)
			this.emitInteraction(current.interaction_trigger_id, this.buildInteraction(current)) //Trigger interaction

		this.currentID = this.getNextID()
	}

	_handleTextInputNext(current, data) {
		const key = current.key || current.id
		this.metadata[key] = data.value

		//Interaction
		if (current.interaction_trigger_id)
			this.emitInteraction(current.interaction_trigger_id, this.buildInteraction(current)) //Trigger interaction

		this.currentID = this.getNextID()
	}

	_handleNumberInputNext(current, data) {
		const key = current.key || current.id
		this.metadata[key] = data.value

		//Interaction
		if (current.interaction_trigger_id)
			this.emitInteraction(current.interaction_trigger_id, this.buildInteraction(current)) //Trigger interaction

		this.currentID = this.getNextID()
	}

	_handleMultiNext(current, data) {
		console.log("_handleMultiNext", current, data)

		const nextID = data.next_id || current.next_id

		if (nextID && !this.dialogues[nextID]) {
			console.warn("Invalid dialogue option entered", data, nextID)
			return; //Nothing we can do
		}

		this.metadata = Object.assign({}, this.metadata, data.meta)

		//Interaction
		if (data.interaction_trigger_id || current.interaction_trigger_id) {
			const interactionID = data.interaction_trigger_id || current.interaction_trigger_id
			this.emitInteraction(interactionID, this.buildInteraction(interactionID)) //Trigger interaction
		}

		this.currentID = nextID //Will be null if interaction is set
	}

	/**
	 * @param interactionID
	 * @param interaction
	 */
	emitInteraction(interactionID, interaction) {
		this.awaitingInteraction = interaction
		this.awaitingInteraction.key = interactionID

		console.log("Emitting Interaction Event", interactionID, interaction)
		window.dispatchEvent(new CustomEvent(`interaction-trigger`, {
			detail: {
				interaction: interaction,
				data: this.metadata,
			}
		}))
	}


	/**
	 * Builds an interaction object from the given dialogue
	 * @param interaction_trigger_id
	 */
	buildInteraction(interaction_trigger_id) {
		const trigger = this.interactions[interaction_trigger_id]
		if (!trigger) {
			return
		}

		return Object.assign({}, trigger)
	}
}